import React from 'react';
import { CalendarIcon, EyeIcon } from 'icons';
import Image from 'next/image';
import Link from 'next/link';

import { extractImageSrc, globalConst, stripHtmlTags } from 'modules/global';

interface IProps {
  desc: string;
  title: string;
  slug?: string;
  image?: string;
  createdAt: string;
  viewCount?: number;
  categoryTitle?: string;
}

const ArticleCards = ({ title, slug, desc, categoryTitle, viewCount, createdAt }: IProps) => (
  <Link href={`${globalConst.pageNames.NEWS}/${slug}`}>
    <div className="mx-3 mb-4 flex cursor-pointer flex-col gap-5 rounded-xl bg-white p-3 hover:text-green-500 sm:flex-row md:mx-0">
      {/* Image Container */}
      {extractImageSrc(desc) ? (
        <div className="sm:w-50 sm:min-w-50 relative h-60 w-full flex-shrink-0 sm:h-31.75 md:min-w-60">
          <Image
            fill
            alt={title}
            title={title}
            className="rounded-xl object-cover"
            src={extractImageSrc(desc) || '/images/no-image.webp'}
          />
        </div>
      ) : (
        <div className="sm:max-w-50 relative flex h-40 w-full items-center justify-center rounded-xl bg-gray-50 md:max-w-60">
          <Image
            alt={title || 'YANGILIKNI TASVIRLOVCHI RASM'}
            src="/images/default-no-image.webp"
            height={70}
            width={70}
            title={title || 'YANGILIKNI TASVIRLOVCHI RASM'}
          />
        </div>
      )}

      {/* Text Content */}
      <div className="flex flex-1 flex-col space-y-4">
        <div>
          <div className="line-clamp-2 font-medium">{title}</div>
          <div className="mt-2 line-clamp-2 text-[0.813rem] font-medium text-gray-500">{stripHtmlTags(desc)}</div>
        </div>

        {/* Category & Meta Info */}
        <div className="mt-auto flex flex-wrap items-end justify-between  gap-2">
          <div className="flex items-center rounded-full bg-gray-50 px-3 py-1 text-[0.625rem] text-gray-500">
            {categoryTitle}
          </div>
          <div className="flex items-center gap-5">
            <div className="flex items-center gap-2 text-xs text-gray-500">
              <EyeIcon />
              {viewCount}
            </div>
            <div className="flex items-center gap-2 text-xs text-gray-500">
              <CalendarIcon />
              {createdAt}
            </div>
          </div>
        </div>
      </div>
    </div>
  </Link>
);

export default ArticleCards;
